<template>
    <div style="width: 100%; position: sticky;top: 0;z-index: 99;">
        <topNav :color="navColor" :style="`background-color: ${navBgc};`"></topNav>
        <menuVue></menuVue>
        <router-view/>
        <div v-show="isScrolledToTarget" class="goTop bgcRed" @click="go_top">
            <i class="el-icon-top" style="margin-right: 2px;"></i>
        </div>
    </div>
</template>

<script>
import topNav from './components/top_nav' //顶部导航状态栏
import menuVue from './components/menu.vue' //菜单项
    export default {
        name:'',
        props:{
            navBgc:{
                type:String,
                default:'#000000'
            },
            navColor:{
                type:String,
                default:'#ffffff'
            }
        },
        data () {
            return {
                isScrolledToTarget: false,
            }
        },
        components: {
            topNav,
            menuVue,
        },
        computed: {},
        beforeMount() {},
        mounted() {
            window.addEventListener('scroll', this.handleScroll)
        },
        beforeDestroy() {
           window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            go_top(){//滚动到 顶部
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // 平滑滚动
                });
            },
            handleScroll() {
                // 获取当前滚动条距离顶部的距离
                // pageYOffset 兼容性好，也可以用 document.documentElement.scrollTop
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                // 判断是否超过 200px
                if (scrollTop > 200) {
                    this.isScrolledToTarget = true
                } else {
                    this.isScrolledToTarget = false
                }
            },
        },
    }

</script>

<style lang='scss' scoped>
.goTop{
    position: fixed;
    right: 20px;
    bottom: 100px;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    color: #ffffff;
    font-size: 26px;
    text-align: center;
    line-height: 40px;
    transition: background-color 0.3s ease; /* 高度变化带动画 */
    cursor: pointer;
    z-index: 9;
    &:hover{
        background-color: #000000;
    }
}
</style>